/* Titles */

export const ITEMS = "Items seleccionados:";

/* Accessors */

export const ACC_ARTICLE = "fullDescription";
export const ACC_SUB_TOTAL = "subtotal";
export const ACC_ARTICLE_DESCRIPTION = "articleDescription";

/* Useful arrays */

export const ACCESSORS = [ACC_ARTICLE, ACC_SUB_TOTAL, ACC_ARTICLE_DESCRIPTION];

/* Others */

export const ID = "Demo";
export const WIDTH = "100%";
